import type React from 'react';

import {
  FilterButton,
  FilterButtonAndChipsWrapper,
  FilterDrawer,
  FilterOverviewLinkList,
  FilterOverviewSearch,
  FilterResultCountAndSortWrapper,
  FilterStateWrapper,
  getFilterChips,
  toggleArrayFilter,
  type FilterButtonProps,
  type UseFilterDrawerReturn,
  type UseFilterReturn,
} from '@helsenorge/designsystem-react/components/Filter';
import FormGroup from '@helsenorge/designsystem-react/components/FormGroup';
import Toggle from '@helsenorge/designsystem-react/components/Toggle';

interface FilterCategory {
  key: string;
  title: string;
}

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filter: UseFilterReturn<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  drawer: UseFilterDrawerReturn<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLabel: (key: any, value: unknown) => string;
  resources: NonNullable<FilterButtonProps['resources']>;
  resultCount: number;
  resultLabel: string;
  title: string;
  categories: FilterCategory[];
  filterData: Array<{ values: Array<{ value: string; displayName?: string }> }>;
}

const Filter: React.FC<Props> = ({ filter, drawer, getLabel, resources, resultCount, resultLabel, title, categories, filterData }) => (
  <FilterStateWrapper>
    <FilterButtonAndChipsWrapper
      filterButtonComponent={<FilterButton onClick={() => drawer.open()} resources={resources} />}
      filterChips={getFilterChips({
        filter,
        getLabel,
        onChipClick: key => (key === 'fritekst' ? drawer.open() : drawer.open(key)),
        onOverflowChipClick: () => drawer.open(),
      })}
      resources={resources}
    />
    <FilterResultCountAndSortWrapper
      resultCount={
        <span role="alert" aria-live="polite">
          <strong>
            {resultCount} {resultLabel}
          </strong>
        </span>
      }
    />
    <FilterDrawer drawer={drawer} onReset={() => filter.resetFiltersToEmpty()} resultCount={resultCount} resources={resources}>
      <FilterDrawer.Overview title={title}>
        <FilterOverviewLinkList
          filter={filter}
          getLabel={getLabel}
          links={categories.map(({ key, title: categoryTitle }) => ({ filterKey: key, title: categoryTitle }))}
          resources={resources}
        />
        <FilterOverviewSearch
          value={(filter.filters.fritekst as string) ?? ''}
          onChange={event => filter.setFilter('fritekst', event.target.value || undefined)}
          clearButtonProps={{ onClick: () => filter.setFilter('fritekst', undefined) }}
          resources={resources}
        />
      </FilterDrawer.Overview>
      {categories.map(({ key, title: categoryTitle }, index) => (
        <FilterDrawer.View key={key} id={key} title={categoryTitle} onReset={() => filter.setFilter(key, undefined)}>
          <FormGroup legend={categoryTitle}>
            {filterData[index].values.map(({ value, displayName }) => (
              <Toggle
                key={value}
                label={[{ text: displayName ?? value }]}
                checked={(filter.filters[key] as string[] | undefined)?.includes(value) ?? false}
                onChange={() => toggleArrayFilter(filter, key, value)}
              />
            ))}
          </FormGroup>
        </FilterDrawer.View>
      ))}
    </FilterDrawer>
  </FilterStateWrapper>
);

export default Filter;
